import { toast } from "react-toastify";
import { useTemplateContext } from "./TemplateContext";
import { useSaveTemplate } from "./templates";
import { useQueryClient } from "react-query";
import { FormButton } from "../../atoms";

type SaveAndContinueButtonProps = {
  onComplete?: () => void;
  isLoading?: boolean;
};
export const SaveAndContinueButton = ({ onComplete = () => {}, isLoading }: SaveAndContinueButtonProps) => {
  const {
    state: { template },
  } = useTemplateContext();

  return <FormButton disabled={!template?.id} loading={isLoading} label={"Save and Continue"} fullWidth onClick={onComplete} />;
};
